<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ]
    };
  },
  mounted() {
  },
};
</script>

<template>
  <Layout>
    <div class="auth-full-bg pt-lg-5 p-4 h-auto">
      <div class="w-100">
        <div class="bg-overlay bg-overlay-background"></div>
      </div>
    </div>
  </Layout>
</template>

<style>
.auth-full-bg {
  background-color: transparent;
}

</style>